import { render, staticRenderFns } from "./pageLoader.vue?vue&type=template&id=4eb9db78&scoped=true"
import script from "./pageLoader.vue?vue&type=script&lang=js"
export * from "./pageLoader.vue?vue&type=script&lang=js"
import style0 from "./pageLoader.vue?vue&type=style&index=0&id=4eb9db78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb9db78",
  null
  
)

export default component.exports